// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ion-padding: 12px;
}

.full-width {
  width: 100%;
}

swiper-container {
  height: 100%;
}

.margin-top-value {
  margin-top: 10px;
}

ion-slides {
  width: 100% !important;
  height: 100% !important;
}

swiper-slide {
  overflow: auto;
}

ion-slide {
  width: 100% !important;
  padding: 10px;
}
ion-slide > ion-col {
  overflow: auto;
  top: 0;
  bottom: 0;
  position: absolute;
  padding: 20px;
  text-align: left;
}

@media (min-width: 991px) {
  ion-content {
    height: 80%;
  }
}

.form-row {
  padding: 5px 25px 20px;
  overflow-x: hidden;
}

.slots-row {
  padding: 5px 25px 20px;
  display: flex;
  flex-direction: column;
}

.form-card {
  background-color: var(--background-color);
  padding: 12px 6px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
}

.phone-item {
  border: none;
}
.phone-item ion-input:first-child {
  margin-right: 10px;
}

/* Global form item styling */
.form-card ion-item {
  --background: #fff;
  border: 1px solid #9a9a9a;
  border-radius: 5px;
  margin-bottom: 9px;
  margin-top: -8px; /* Pull up to meet floating label */
  --min-height: 44px;
  --highlight-height: 0;
}
.form-card ion-item.ion-invalid.ion-touched {
  border-color: var(--ion-color-danger);
}
.form-card ion-item ion-input {
  --padding-start: 10px;
  margin-bottom: 0;
  border-bottom: none;
}

.label-error {
  color: rgb(119, 25, 25);
}

ion-card {
  margin: 0;
  padding: 12px;
  border-radius: 0px;
  text-align: initial;
  --color: var(--ion-color-black);
  --preorder-type-chip-border-color: var(--ion-color-primary);
  overflow: auto;
  word-break: break-word;
  border: 0.5px solid #e2dcd5;
  box-shadow: 0px 0px 35px 0px rgba(0, 0, 0, 0.0588235294);
}
ion-card:first-of-type {
  margin-bottom: 10px;
}
ion-card ion-card-content {
  border-top: 0.5px solid #e2dcd5;
  padding: 0px;
  line-break: auto !important;
}
ion-card ion-card-content:first-of-type {
  border: none;
}
ion-card ion-card-content .padding-card {
  padding: 10px;
}
ion-card ion-col {
  padding: 0;
}

ion-card-header {
  background: white;
  color: var(--ion-color-black);
  padding: 0;
}
ion-card-header .separator {
  margin-block: 20px;
}
ion-card-header ion-button {
  --background: transparent;
  --color: #54504c;
  border: 1.5px solid white;
  text-transform: none;
}

.left-col {
  font-family: AppFontBold;
  font-size: 13px;
  line-height: 16px;
  text-align: left;
  color: #000;
}
@media (min-width: 991px) {
  .left-col {
    font-size: 16px;
    line-height: 20px;
  }
}

.right-col {
  font-family: AppFont;
  font-size: 10px;
  line-height: 15px;
  text-align: right;
  color: #1a1a18;
}
@media (min-width: 991px) {
  .right-col {
    font-size: 14px;
    line-height: 20px;
  }
}

.border-top-light-blue {
  border-top: 0.5px solid #e2dcd5;
}
.border-top-light-blue h3 {
  margin-top: 10px;
  place-self: center;
  font-size: 16px;
  font-family: AppFontBold, sans-serif;
}

ion-chip {
  margin: 0;
  margin-left: auto;
  background: var(--ion-color-primary);
  padding: 2px 10px;
  border-radius: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: unset;
  width: -moz-fit-content;
  width: fit-content;
}
ion-chip ion-label {
  font-family: AppFontBold;
  font-size: 9px;
  line-height: 10px;
  text-align: center;
  text-transform: uppercase;
  color: #fff;
}
@media (min-width: 991px) {
  ion-chip ion-label {
    font-size: 12px;
    line-height: 14px;
  }
}

.card-content-md {
  font-weight: unset;
}

.adds-price {
  padding-left: 5px;
  color: var(--ion-color-medium);
}

.order-at-header {
  text-align: left;
  margin: 10px;
  margin-left: 0px;
  font-size: 20px;
  line-height: 24px;
  text-transform: uppercase;
  font-family: AppFontBold, sans-serif;
  font-weight: bold;
  color: var(--ion-color-black);
}

.section-header {
  text-align: left;
  margin: 20px 0 10px 0;
  font-size: 18px;
  line-height: 22px;
  text-transform: uppercase;
  font-weight: bold;
  color: var(--ion-color-black);
  padding: 10px 0;
}

ion-label {
  text-align: left;
}

.padding {
  padding: 25px;
}

.icon-edit {
  zoom: 2;
}

.privacy {
  font-family: OpenSans, sans-serif;
  font-size: 11px;
  color: var(--ion-color-black);
}

.phoneCountry {
  max-width: 15%;
}
@media (min-width: 991px) {
  .phoneCountry {
    max-width: 10%;
  }
}

ion-card-title {
  font-family: AppFontBold, sans-serif;
  text-transform: uppercase;
  color: var(--ion-color-black);
  font-size: 18px;
}

.separator {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.separator .line {
  border: none; /* Remove dotted line */
  border-bottom: 1px solid #e0e0e0; /* Add thin solid line if desired, or just remove */
  height: 1px;
}

.footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  padding: 10px 17px;
  box-shadow: none;
}

.button-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 12px;
  margin-bottom: 10px;
}
.button-row .footer-btn {
  min-height: 46px;
  height: 46px;
  width: 100%;
  border-radius: 8px;
  --padding-start: 5px;
  --padding-end: 5px;
  --padding-top: 5px;
  --padding-bottom: 5px;
  --background: #d82c4d; /* Red specific from design reference */
  --box-shadow: none;
  margin: 0 auto;
  position: relative;
}
.button-row .footer-btn.hide {
  opacity: 0;
  pointer-events: none;
}
.button-row .footer-btn .footer-btn-text {
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 14px;
  margin: 0 auto;
  color: #fff;
  text-transform: none;
  letter-spacing: 0.5px;
}

.elternative-button-row {
  margin-bottom: 10px;
}
.elternative-button-row ion-button {
  width: 100%;
  min-height: 45px;
}

.footer-info-title {
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 19px;
}

ion-radio-group {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 12px;
  margin-left: 0;
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 17px;
  text-align: left;
  color: #000;
}
@media (max-width: 992px) {
  ion-radio-group {
    width: auto;
    margin-left: 0;
    line-break: anywhere;
    max-width: 100%;
  }
}
ion-radio-group ion-radio {
  --border-width: 1px;
  --border-color: #000;
  --border-color-checked: #000;
  --background-checked: transparent;
  --color-checked: #000;
  --color: #000;
  margin-left: 0;
  padding-left: 0;
}
ion-radio-group ion-radio::part(label) {
  text-overflow: initial;
  white-space: initial;
  text-align: left !important;
  justify-content: flex-start !important;
  margin-left: 0;
  padding-left: 8px;
}
ion-radio-group .radio-checked::part(mark) {
  transform: scale3d(1.4, 1.4, 1);
}
ion-radio-group .additional-info {
  display: block;
  margin-top: 12px;
  font-family: AppFont;
  font-size: 10px;
  line-height: 13px;
  text-align: left;
  color: #1a1a18;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  white-space: normal;
  max-width: 100%;
}

.main-overview-row {
  padding: 16px 25px;
}

.articles-row ~ :not(.tip-row) {
  margin-bottom: 12px;
}

.tip-row {
  margin-bottom: 12px;
}

app-tip {
  display: block;
  margin-bottom: 12px;
}

.article-row {
  margin-bottom: 8px;
}

.name-col {
  font-family: AppFontBold;
  font-size: 13px;
  line-height: 16px;
  text-align: left;
  color: #000;
}
@media (min-width: 991px) {
  .name-col {
    font-size: 16px;
    line-height: 20px;
  }
}

.article-price {
  font-family: AppFontBold;
  font-size: 12px;
  line-height: 15px;
  text-align: right;
  color: #000;
}
@media (min-width: 991px) {
  .article-price {
    font-size: 14px;
    line-height: 20px;
  }
}

.total-row {
  margin-top: 20px;
}
.total-row .total-title {
  font-family: AppFontBold;
  font-size: 13px;
  line-height: 16px;
  text-align: left;
  color: #000;
  margin: 0;
  text-transform: uppercase;
}
@media (min-width: 991px) {
  .total-row .total-title {
    font-size: 16px;
    line-height: 20px;
  }
}
.total-row .price {
  font-family: AppFontBold;
  font-size: 15px;
  line-height: 15px;
  text-align: right;
  color-scheme: #000;
  margin: 0;
}
@media (min-width: 991px) {
  .total-row .price {
    font-size: 16px;
    line-height: 20px;
  }
}

.container {
  position: relative;
  margin-bottom: 20px;
}
.container ion-label {
  z-index: 999;
  font-size: 13px;
  line-height: 17.8px;
  color: #785526;
  font-family: AppFontSemiBold;
}

.input-error {
  --color: var(--ion-color-danger);
  --placeholder-color: var(--ion-color-danger);
  margin-bottom: 0 !important;
  color: var(--ion-color-danger);
  font-size: 11px;
  display: block;
  margin-top: 5px;
}

.input_info {
  color: var(--ion-color-danger);
  font-size: 11px;
  display: block;
  margin-top: 2px;
}

.error_container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.error-text {
  margin: 4px 0;
  width: 100%;
  color: var(--ion-color-danger);
  font-size: 11px;
}

.input_group-1 {
  display: flex;
  justify-content: center;
  align-items: center;
}
.input_group-1 .lock-icon {
  height: 12px;
}
@media (min-width: 991px) {
  .input_group-1 .lock-icon {
    margin: 2px -10px 15px 5px;
  }
}
.input_group-1--1 {
  width: 70% !important;
  margin-right: 0;
}
.input_group-1--2 {
  margin: 0px 0px 20px 7px;
  width: 30% !important;
}

.input_group-2 {
  display: flex;
  justify-content: center;
  align-items: center;
}
.input_group-2 .lock-icon {
  height: 12px;
}
@media (min-width: 991px) {
  .input_group-2 .lock-icon {
    margin: 2px -10px 15px 5px;
  }
}
.input_group-2--1 {
  width: 30%;
  margin-right: 0;
}
.input_group-2--2 {
  width: 70%;
  margin: 0px 0px 20px 7px;
}

.option-name ion-col {
  font-size: 12px !important;
}

/* Overview Card Styling */
.overview-card {
  background: #fff;
  border-radius: 8px; /* Rounded corners for card */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05); /* Soft shadow */
  margin: 10px 0; /* Spacing between cards */
  width: 100%;
}

ion-card-header {
  padding: 15px 15px 10px;
  border-bottom: 1px solid #f2f2f2;
}

ion-card-title {
  font-family: AppFontBold;
  font-size: 18px;
  color: var(--ion-color-black);
  text-transform: none; /* As per screenshot example */
}

.edit-icon-wrapper {
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.edit-icon-wrapper ion-icon {
  font-size: 18px;
  color: #333;
}

.info-list {
  padding: 10px 0;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 4px 0;
  font-size: 14px;
}

.label-col {
  flex: 0 0 40%;
  font-family: AppFontBold;
  color: #333;
  text-align: left;
  padding-left: 0;
}

.value-col {
  flex: 1;
  text-align: right;
  color: #666;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 0;
}

/* Badges */
.badge {
  background-color: #333; /* Dark background */
  color: #fff;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  text-transform: uppercase;
  font-weight: bold;
}

.number-badge {
  border: 1px solid #333;
  border-radius: 12px;
  padding: 2px 10px;
  font-weight: bold;
  color: #333;
  background: transparent;
}

/* Input Styling Updates (Previous Context) */
.stacked {
  position: relative;
  top: 1px;
  left: 10px;
  z-index: 2;
  background: var(--ion-background-color);
  padding-inline: 5px;
  width: -moz-fit-content;
  width: fit-content;
}

.separator_white_wrapper {
  width: 100%;
  padding: 20px 25px;
}
.separator_white_wrapper .separator_white {
  height: 14px;
  width: 100%;
  border-bottom: 2px dotted white;
}

.amici-club {
  width: 100%;
  padding: 5px 7px 15px;
}
.amici-club_main {
  display: flex;
}
.amici-club_main .text-content {
  width: 40%;
  display: flex;
  flex-direction: column;
}
.amici-club_main h4 {
  height: 18px;
  font-weight: 700;
  margin-bottom: 8px;
}
.amici-club_main span {
  font-size: 11px;
  color: var(--ion-color-dark);
  line-height: 1;
}
.amici-club_main img {
  margin-right: 14px;
}
.amici-club_main .points {
  margin-left: auto;
  position: relative;
  width: 54px;
  height: 54px;
}
.amici-club_main .points img {
  position: absolute;
  width: 100%;
  height: 100%;
}
.amici-club_main .points span {
  position: absolute;
  left: 50%;
  font-family: AppFontBold;
  font-size: 15px;
  top: 50%;
  transform: translate(-50%, -60%);
}
.amici-club_footer {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}
.amici-club_footer ion-button {
  width: 47%;
  min-height: 37px;
  height: 37px;
}
.amici-club_footer ion-button:last-child {
  --background: white;
  color: var(--ion-color-primary);
  --border-color: var(--ion-color-primary);
}

.din-pro-cond-med {
  margin-inline-start: 0;
  padding-top: 2px;
  font-family: AppFontAlt;
  font-size: 10px;
  line-height: 16.9px;
  text-align: left;
  color: #1e1e1c;
}

.checkbox-item {
  display: flex;
  align-items: flex-start;
}
.checkbox-item ion-checkbox {
  --border-color: #41403b80;
  --border-color-checked: var(--randy-red-dark);
  --checkbox-background-checked: var(--randy-red-dark);
  --checkbox-background: transparent;
  --checkmark-color: #fff;
}

.underline {
  position: relative;
  z-index: 10;
  text-decoration: none;
}
.underline a {
  color: var(--ion-color-black);
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/app/components/checkout-modal/checkout-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,mBAAA;AADD;;AAIA;EACC,WAAA;AADD;;AAGA;EACC,YAAA;AAAD;;AAEA;EACC,gBAAA;AACD;;AACA;EACC,sBAAA;EACA,uBAAA;AAED;;AACA;EACC,cAAA;AAED;;AACA;EACC,sBAAA;EACA,aAAA;AAED;AADC;EACC,cAAA;EACA,MAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AAGF;;ACnCE;EDmCF;IAEE,WAAA;EAGA;AACF;;AADA;EACC,sBAAA;EACA,kBAAA;AAID;;AAFA;EACC,sBAAA;EAEA,aAAA;EACA,sBAAA;AAID;;AADA;EACC,yCAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAID;;AADA;EACC,YAAA;AAID;AAHC;EACC,kBAAA;AAKF;;AADA,6BAAA;AACA;EACC,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA,EAAA,mCAAA;EACA,kBAAA;EACA,qBAAA;AAID;AAFC;EACC,qCAAA;AAIF;AADC;EACC,qBAAA;EACA,gBAAA;EACA,mBAAA;AAGF;;AACA;EACC,uBAAA;AAED;;AAAA;EACC,SAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EAEA,+BAAA;EACA,2DAAA;EACA,cAAA;EACA,sBAAA;EACA,2BAAA;EACA,wDAAA;AAED;AAAC;EACC,mBAAA;AAEF;AACC;EACC,+BAAA;EACA,YAAA;EACA,2BAAA;AACF;AAAE;EACC,YAAA;AAEH;AAAE;EACC,aAAA;AAEH;AAEC;EACC,UAAA;AAAF;;AAIA;EACC,iBAAA;EACA,6BAAA;EACA,UAAA;AADD;AAGC;EACC,kBAAA;AADF;AAIC;EACC,yBAAA;EACA,gBAAA;EACA,yBAAA;EACA,oBAAA;AAFF;;AAMA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,gBAAA;EACA,WAAA;AAJD;AC/IE;ED6IF;IAQE,eAAA;IACA,iBAAA;EAFA;AACF;;AAKA;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EAEA,iBAAA;EAEA,cAAA;AAJD;AC7JE;ED0JF;IASE,eAAA;IACA,iBAAA;EAFA;AACF;;AAKA;EACC,+BAAA;AAFD;AAGC;EACC,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;AADF;;AAKA;EACC,SAAA;EACA,iBAAA;EACA,oCAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EAAA,kBAAA;AAFD;AAIC;EACC,wBAAA;EACA,cAAA;EACA,iBAAA;EAEA,kBAAA;EACA,yBAAA;EACA,WAAA;AAHF;AClME;ED8LD;IASE,eAAA;IACA,iBAAA;EADD;AACF;;AAKA;EACC,kBAAA;AAFD;;AAKA;EACC,iBAAA;EACA,8BAAA;AAFD;;AAIA;EACC,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,oCAAA;EACA,iBAAA;EACA,6BAAA;AADD;;AAIA;EACC,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,6BAAA;EACA,eAAA;AADD;;AAGA;EACC,gBAAA;AAAD;;AAGA;EACC,aAAA;AAAD;;AAEA;EACC,OAAA;AACD;;AACA;EACC,iCAAA;EACA,eAAA;EACA,6BAAA;AAED;;AAAA;EACC,cAAA;AAGD;AC9PE;ED0PF;IAGE,cAAA;EAKA;AACF;;AAFA;EACC,oCAAA;EACA,yBAAA;EACA,6BAAA;EACA,eAAA;AAKD;;AAFA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAKD;AAHC;EACC,YAAA,EAAA,uBAAA;EACA,gCAAA,EAAA,mDAAA;EACA,WAAA;AAKF;;AADA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AAID;;AADA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAID;AAFC;EACC,gBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA,EAAA,uCAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAIF;AAFE;EACC,UAAA;EACA,oBAAA;AAIH;AADE;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,oBAAA;EACA,qBAAA;AAGH;;AAEA;EACC,mBAAA;AACD;AAAC;EACC,WAAA;EACA,gBAAA;AAEF;;AAEA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;AACD;;AAEA;EACC,aAAA;EACA,2BAAA;EAEA,mBAAA;EACA,cAAA;EAEA,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,gBAAA;EACA,WAAA;AAFD;ACvVE;ED6UF;IAcE,WAAA;IACA,cAAA;IACA,oBAAA;IACA,eAAA;EAAA;AACF;AACC;EACC,mBAAA;EAEA,oBAAA;EACA,4BAAA;EACA,iCAAA;EACA,qBAAA;EACA,aAAA;EAEA,cAAA;EACA,eAAA;AADF;AAGE;EACC,sBAAA;EACA,oBAAA;EACA,2BAAA;EACA,sCAAA;EACA,cAAA;EACA,iBAAA;AADH;AAIC;EACC,+BAAA;AAFF;AAKC;EACC,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAHF;;AAOA;EACC,kBAAA;AAJD;;AAOA;EACC,mBAAA;AAJD;;AAOA;EACC,mBAAA;AAJD;;AAOA;EACC,cAAA;EACA,mBAAA;AAJD;;AAOA;EACC,kBAAA;AAJD;;AAOA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,gBAAA;EACA,WAAA;AALD;ACraE;EDoaF;IAQE,eAAA;IACA,iBAAA;EAHA;AACF;;AAKA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,iBAAA;EACA,WAAA;AAHD;ACnbE;EDgbF;IAQE,eAAA;IACA,iBAAA;EADA;AACF;;AAIA;EACC,gBAAA;AADD;AAGC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;EACA,yBAAA;AADF;ACtcE;EDgcD;IASE,eAAA;IACA,iBAAA;EACD;AACF;AAEC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,iBAAA;EACA,kBAAA;EACA,SAAA;AADF;ACpdE;ED8cD;IASE,eAAA;IACA,iBAAA;EACD;AACF;;AAGA;EACC,kBAAA;EACA,mBAAA;AAAD;AACC;EACC,YAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,4BAAA;AACF;;AAEA;EACC,gCAAA;EACA,4CAAA;EACA,2BAAA;EACA,8BAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AACD;;AAEA;EACC,8BAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AACD;;AAEA;EACC,aAAA;EACA,sBAAA;EACA,WAAA;AACD;;AAEA;EACC,aAAA;EACA,WAAA;EACA,8BAAA;EACA,eAAA;AACD;;AACA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;AAED;AADC;EACC,YAAA;AAGF;AC7gBE;EDygBD;IAGE,0BAAA;EAKD;AACF;AAHC;EACC,qBAAA;EACA,eAAA;AAKF;AAHC;EACC,wBAAA;EACA,qBAAA;AAKF;;AADA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;AAID;AAFC;EACC,YAAA;AAIF;ACniBE;ED8hBD;IAGE,0BAAA;EAMD;AACF;AAHC;EACC,UAAA;EACA,eAAA;AAKF;AAFC;EACC,UAAA;EACA,wBAAA;AAIF;;AACC;EACC,0BAAA;AAEF;;AAEA,0BAAA;AACA;EACC,gBAAA;EACA,kBAAA,EAAA,6BAAA;EACA,0CAAA,EAAA,gBAAA;EACA,cAAA,EAAA,0BAAA;EACA,WAAA;AACD;;AAEA;EACC,uBAAA;EACA,gCAAA;AACD;;AAEA;EACC,wBAAA;EACA,eAAA;EACA,6BAAA;EACA,oBAAA,EAAA,8BAAA;AACD;;AAEA;EACC,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AACD;AACC;EACC,eAAA;EACA,WAAA;AACF;;AAGA;EACC,eAAA;AAAD;;AAGA;EACC,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAAD;;AAGA;EACC,aAAA;EACA,wBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AAAD;;AAGA;EACC,OAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAAD;;AAGA,WAAA;AACA;EACC,sBAAA,EAAA,oBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;AAAD;;AAGA;EACC,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,uBAAA;AAAD;;AAGA,6CAAA;AACA;EACC,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,uCAAA;EACA,mBAAA;EACA,uBAAA;EAAA,kBAAA;AAAD;;AAEA;EACC,WAAA;EACA,kBAAA;AACD;AAAC;EACC,YAAA;EACA,WAAA;EACA,+BAAA;AAEF;;AAEA;EACC,WAAA;EACA,qBAAA;AACD;AACC;EACC,aAAA;AACF;AAAE;EACC,UAAA;EACA,aAAA;EACA,sBAAA;AAEH;AAAE;EACC,YAAA;EACA,gBAAA;EACA,kBAAA;AAEH;AAAE;EACC,eAAA;EACA,4BAAA;EACA,cAAA;AAEH;AAAE;EACC,kBAAA;AAEH;AACE;EACC,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AACH;AAAG;EACC,kBAAA;EACA,WAAA;EACA,YAAA;AAEJ;AAAG;EACC,kBAAA;EACA,SAAA;EACA,wBAAA;EACA,eAAA;EACA,QAAA;EACA,gCAAA;AAEJ;AAEC;EACC,aAAA;EACA,8BAAA;EACA,gBAAA;AAAF;AACE;EACC,UAAA;EACA,gBAAA;EACA,YAAA;AACH;AACE;EACC,mBAAA;EACA,+BAAA;EACA,wCAAA;AACH;;AAIA;EACC,sBAAA;EACA,gBAAA;EAEA,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAFD;;AAKA;EACC,aAAA;EACA,uBAAA;AAFD;AAIC;EAIC,yBAAA;EACA,6CAAA;EACA,oDAAA;EACA,kCAAA;EACA,uBAAA;AALF;;AASA;EACC,kBAAA;EACA,WAAA;EACA,qBAAA;AAND;AAQC;EACC,6BAAA;EACA,0BAAA;AANF","sourcesContent":["@use '../../../theme/mixins' as *;\n\n:root {\n\t--ion-padding: 12px;\n}\n\n.full-width {\n\twidth: 100%;\n}\nswiper-container {\n\theight: 100%;\n}\n.margin-top-value {\n\tmargin-top: 10px;\n}\nion-slides {\n\twidth: 100% !important;\n\theight: 100% !important;\n}\n\nswiper-slide {\n\toverflow: auto;\n}\n\nion-slide {\n\twidth: 100% !important;\n\tpadding: 10px;\n\t> ion-col {\n\t\toverflow: auto;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tposition: absolute;\n\t\tpadding: 20px;\n\t\ttext-align: left;\n\t}\n}\nion-content {\n\t@include desktop {\n\t\theight: 80%;\n\t}\n}\n.form-row {\n\tpadding: 5px 25px 20px;\n\toverflow-x: hidden;\n}\n.slots-row {\n\tpadding: 5px 25px 20px;\n\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.form-card {\n\tbackground-color: var(--background-color);\n\tpadding: 12px 6px;\n\tmargin-top: 20px;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.phone-item {\n\tborder: none;\n\tion-input:first-child {\n\t\tmargin-right: 10px;\n\t}\n}\n\n/* Global form item styling */\n.form-card ion-item {\n\t--background: #fff;\n\tborder: 1px solid #9a9a9a;\n\tborder-radius: 5px;\n\tmargin-bottom: 9px;\n\tmargin-top: -8px; /* Pull up to meet floating label */\n\t--min-height: 44px;\n\t--highlight-height: 0;\n\n\t&.ion-invalid.ion-touched {\n\t\tborder-color: var(--ion-color-danger);\n\t}\n\n\tion-input {\n\t\t--padding-start: 10px;\n\t\tmargin-bottom: 0;\n\t\tborder-bottom: none;\n\t}\n}\n\n.label-error {\n\tcolor: rgb(119, 25, 25);\n}\nion-card {\n\tmargin: 0;\n\tpadding: 12px;\n\tborder-radius: 0px;\n\ttext-align: initial;\n\n\t--color: var(--ion-color-black);\n\t--preorder-type-chip-border-color: var(--ion-color-primary);\n\toverflow: auto;\n\tword-break: break-word;\n\tborder: 0.5px solid #e2dcd5;\n\tbox-shadow: 0px 0px 35px 0px #0000000f;\n\n\t&:first-of-type {\n\t\tmargin-bottom: 10px;\n\t}\n\n\tion-card-content {\n\t\tborder-top: 0.5px solid #e2dcd5;\n\t\tpadding: 0px;\n\t\tline-break: auto !important;\n\t\t&:first-of-type {\n\t\t\tborder: none;\n\t\t}\n\t\t.padding-card {\n\t\t\tpadding: 10px;\n\t\t}\n\t}\n\n\tion-col {\n\t\tpadding: 0;\n\t}\n}\n\nion-card-header {\n\tbackground: white;\n\tcolor: var(--ion-color-black);\n\tpadding: 0;\n\n\t.separator {\n\t\tmargin-block: 20px;\n\t}\n\n\tion-button {\n\t\t--background: transparent;\n\t\t--color: #54504c;\n\t\tborder: 1.5px solid white;\n\t\ttext-transform: none;\n\t}\n}\n\n.left-col {\n\tfont-family: AppFontBold;\n\tfont-size: 13px;\n\tline-height: 16px;\n\n\ttext-align: left;\n\tcolor: #000;\n\t@include desktop {\n\t\tfont-size: 16px;\n\t\tline-height: 20px;\n\t}\n}\n\n.right-col {\n\tfont-family: AppFont;\n\tfont-size: 10px;\n\tline-height: 15px;\n\n\ttext-align: right;\n\n\tcolor: #1a1a18;\n\t@include desktop {\n\t\tfont-size: 14px;\n\t\tline-height: 20px;\n\t}\n}\n\n.border-top-light-blue {\n\tborder-top: 0.5px solid #e2dcd5;\n\th3 {\n\t\tmargin-top: 10px;\n\t\tplace-self: center;\n\t\tfont-size: 16px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t}\n}\n\nion-chip {\n\tmargin: 0;\n\tmargin-left: auto;\n\tbackground: var(--ion-color-primary);\n\tpadding: 2px 10px;\n\tborder-radius: 28px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmin-height: unset;\n\twidth: fit-content;\n\n\tion-label {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 9px;\n\t\tline-height: 10px;\n\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t\tcolor: #fff;\n\t\t@include desktop {\n\t\t\tfont-size: 12px;\n\t\t\tline-height: 14px;\n\t\t}\n\t}\n}\n\n.card-content-md {\n\tfont-weight: unset;\n}\n\n.adds-price {\n\tpadding-left: 5px;\n\tcolor: var(--ion-color-medium);\n}\n.order-at-header {\n\ttext-align: left;\n\tmargin: 10px;\n\tmargin-left: 0px;\n\tfont-size: 20px;\n\tline-height: 24px;\n\ttext-transform: uppercase;\n\tfont-family: AppFontBold, sans-serif;\n\tfont-weight: bold;\n\tcolor: var(--ion-color-black);\n}\n\n.section-header {\n\ttext-align: left;\n\tmargin: 20px 0 10px 0;\n\tfont-size: 18px;\n\tline-height: 22px;\n\ttext-transform: uppercase;\n\tfont-weight: bold;\n\tcolor: var(--ion-color-black);\n\tpadding: 10px 0;\n}\nion-label {\n\ttext-align: left;\n}\n\n.padding {\n\tpadding: 25px;\n}\n.icon-edit {\n\tzoom: 2;\n}\n.privacy {\n\tfont-family: OpenSans, sans-serif;\n\tfont-size: 11px;\n\tcolor: var(--ion-color-black);\n}\n.phoneCountry {\n\tmax-width: 15%;\n\t@include desktop {\n\t\tmax-width: 10%;\n\t}\n}\n\nion-card-title {\n\tfont-family: AppFontBold, sans-serif;\n\ttext-transform: uppercase;\n\tcolor: var(--ion-color-black);\n\tfont-size: 18px;\n}\n\n.separator {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\n\t.line {\n\t\tborder: none; /* Remove dotted line */\n\t\tborder-bottom: 1px solid #e0e0e0; /* Add thin solid line if desired, or just remove */\n\t\theight: 1px;\n\t}\n}\n\n.footer {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: stretch;\n\tpadding: 10px 17px;\n\tbox-shadow: none;\n}\n\n.button-row {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tflex-wrap: wrap;\n\tmargin-top: 12px;\n\tmargin-bottom: 10px;\n\n\t.footer-btn {\n\t\tmin-height: 46px;\n\t\theight: 46px;\n\t\twidth: 100%;\n\t\tborder-radius: 8px;\n\t\t--padding-start: 5px;\n\t\t--padding-end: 5px;\n\t\t--padding-top: 5px;\n\t\t--padding-bottom: 5px;\n\t\t--background: #d82c4d; /* Red specific from design reference */\n\t\t--box-shadow: none;\n\t\tmargin: 0 auto;\n\t\tposition: relative;\n\n\t\t&.hide {\n\t\t\topacity: 0;\n\t\t\tpointer-events: none;\n\t\t}\n\n\t\t.footer-btn-text {\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 14px;\n\t\t\tmargin: 0 auto;\n\t\t\tcolor: #fff;\n\t\t\ttext-transform: none;\n\t\t\tletter-spacing: 0.5px;\n\t\t}\n\t}\n}\n\n.elternative-button-row {\n\tmargin-bottom: 10px;\n\tion-button {\n\t\twidth: 100%;\n\t\tmin-height: 45px;\n\t}\n}\n\n.footer-info-title {\n\tfont-family: AppFontBold;\n\tfont-size: 16px;\n\tline-height: 19px;\n}\n\nion-radio-group {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\n\tmargin-bottom: 12px;\n\tmargin-left: 0;\n\n\tfont-family: AppFontBold;\n\tfont-size: 14px;\n\tline-height: 17px;\n\n\ttext-align: left;\n\tcolor: #000;\n\t@include mobile {\n\t\twidth: auto;\n\t\tmargin-left: 0;\n\t\tline-break: anywhere;\n\t\tmax-width: 100%;\n\t}\n\tion-radio {\n\t\t--border-width: 1px;\n\n\t\t--border-color: #000;\n\t\t--border-color-checked: #000;\n\t\t--background-checked: transparent;\n\t\t--color-checked: #000;\n\t\t--color: #000;\n\n\t\tmargin-left: 0;\n\t\tpadding-left: 0;\n\n\t\t&::part(label) {\n\t\t\ttext-overflow: initial;\n\t\t\twhite-space: initial;\n\t\t\ttext-align: left !important;\n\t\t\tjustify-content: flex-start !important;\n\t\t\tmargin-left: 0;\n\t\t\tpadding-left: 8px;\n\t\t}\n\t}\n\t.radio-checked::part(mark) {\n\t\ttransform: scale3d(1.4, 1.4, 1);\n\t}\n\n\t.additional-info {\n\t\tdisplay: block;\n\t\tmargin-top: 12px;\n\t\tfont-family: AppFont;\n\t\tfont-size: 10px;\n\t\tline-height: 13px;\n\t\ttext-align: left;\n\t\tcolor: #1a1a18;\n\t\tword-wrap: break-word;\n\t\toverflow-wrap: break-word;\n\t\thyphens: auto;\n\t\twhite-space: normal;\n\t\tmax-width: 100%;\n\t}\n}\n\n.main-overview-row {\n\tpadding: 16px 25px;\n}\n\n.articles-row ~ :not(.tip-row) {\n\tmargin-bottom: 12px;\n}\n\n.tip-row {\n\tmargin-bottom: 12px;\n}\n\napp-tip {\n\tdisplay: block;\n\tmargin-bottom: 12px;\n}\n\n.article-row {\n\tmargin-bottom: 8px;\n}\n\n.name-col {\n\tfont-family: AppFontBold;\n\tfont-size: 13px;\n\tline-height: 16px;\n\n\ttext-align: left;\n\tcolor: #000;\n\t@include desktop {\n\t\tfont-size: 16px;\n\t\tline-height: 20px;\n\t}\n}\n.article-price {\n\tfont-family: AppFontBold;\n\tfont-size: 12px;\n\tline-height: 15px;\n\n\ttext-align: right;\n\tcolor: #000;\n\t@include desktop {\n\t\tfont-size: 14px;\n\t\tline-height: 20px;\n\t}\n}\n\n.total-row {\n\tmargin-top: 20px;\n\n\t.total-title {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 13px;\n\t\tline-height: 16px;\n\t\ttext-align: left;\n\t\tcolor: #000;\n\t\tmargin: 0;\n\t\ttext-transform: uppercase;\n\t\t@include desktop {\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 20px;\n\t\t}\n\t}\n\n\t.price {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 15px;\n\t\tline-height: 15px;\n\n\t\ttext-align: right;\n\t\tcolor-scheme: #000;\n\t\tmargin: 0;\n\t\t@include desktop {\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 20px;\n\t\t}\n\t}\n}\n\n.container {\n\tposition: relative;\n\tmargin-bottom: 20px;\n\tion-label {\n\t\tz-index: 999;\n\t\tfont-size: 13px;\n\t\tline-height: 17.8px;\n\t\tcolor: #785526;\n\t\tfont-family: AppFontSemiBold;\n\t}\n}\n.input-error {\n\t--color: var(--ion-color-danger);\n\t--placeholder-color: var(--ion-color-danger);\n\tmargin-bottom: 0 !important;\n\tcolor: var(--ion-color-danger);\n\tfont-size: 11px;\n\tdisplay: block;\n\tmargin-top: 5px;\n}\n\n.input_info {\n\tcolor: var(--ion-color-danger);\n\tfont-size: 11px;\n\tdisplay: block;\n\tmargin-top: 2px;\n}\n\n.error_container {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n}\n\n.error-text {\n\tmargin: 4px 0;\n\twidth: 100%;\n\tcolor: var(--ion-color-danger);\n\tfont-size: 11px;\n}\n.input_group-1 {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\t.lock-icon {\n\t\theight: 12px;\n\t\t@include desktop {\n\t\t\tmargin: 2px -10px 15px 5px;\n\t\t}\n\t}\n\t&--1 {\n\t\twidth: 70% !important;\n\t\tmargin-right: 0;\n\t}\n\t&--2 {\n\t\tmargin: 0px 0px 20px 7px;\n\t\twidth: 30% !important;\n\t}\n}\n\n.input_group-2 {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\t.lock-icon {\n\t\theight: 12px;\n\t\t@include desktop {\n\t\t\tmargin: 2px -10px 15px 5px;\n\t\t}\n\t}\n\n\t&--1 {\n\t\twidth: 30%;\n\t\tmargin-right: 0;\n\t}\n\n\t&--2 {\n\t\twidth: 70%;\n\t\tmargin: 0px 0px 20px 7px;\n\t}\n}\n\n.option-name {\n\tion-col {\n\t\tfont-size: 12px !important;\n\t}\n}\n\n/* Overview Card Styling */\n.overview-card {\n\tbackground: #fff;\n\tborder-radius: 8px; /* Rounded corners for card */\n\tbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.05); /* Soft shadow */\n\tmargin: 10px 0; /* Spacing between cards */\n\twidth: 100%;\n}\n\nion-card-header {\n\tpadding: 15px 15px 10px;\n\tborder-bottom: 1px solid #f2f2f2;\n}\n\nion-card-title {\n\tfont-family: AppFontBold;\n\tfont-size: 18px;\n\tcolor: var(--ion-color-black);\n\ttext-transform: none; /* As per screenshot example */\n}\n\n.edit-icon-wrapper {\n\tborder: 1px solid #ccc;\n\tborder-radius: 4px;\n\twidth: 32px;\n\theight: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcursor: pointer;\n\n\tion-icon {\n\t\tfont-size: 18px;\n\t\tcolor: #333;\n\t}\n}\n\n.info-list {\n\tpadding: 10px 0;\n}\n\n.info-row {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: flex-start;\n\tpadding: 4px 0;\n\tfont-size: 14px;\n}\n\n.label-col {\n\tflex: 0 0 40%;\n\tfont-family: AppFontBold;\n\tcolor: #333;\n\ttext-align: left;\n\tpadding-left: 0;\n}\n\n.value-col {\n\tflex: 1;\n\ttext-align: right;\n\tcolor: #666;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\talign-items: center;\n\tpadding-right: 0;\n}\n\n/* Badges */\n.badge {\n\tbackground-color: #333; /* Dark background */\n\tcolor: #fff;\n\tpadding: 4px 10px;\n\tborder-radius: 12px;\n\tfont-size: 11px;\n\ttext-transform: uppercase;\n\tfont-weight: bold;\n}\n\n.number-badge {\n\tborder: 1px solid #333;\n\tborder-radius: 12px;\n\tpadding: 2px 10px;\n\tfont-weight: bold;\n\tcolor: #333;\n\tbackground: transparent;\n}\n\n/* Input Styling Updates (Previous Context) */\n.stacked {\n\tposition: relative;\n\ttop: 1px;\n\tleft: 10px;\n\tz-index: 2;\n\tbackground: var(--ion-background-color);\n\tpadding-inline: 5px;\n\twidth: fit-content;\n}\n.separator_white_wrapper {\n\twidth: 100%;\n\tpadding: 20px 25px;\n\t.separator_white {\n\t\theight: 14px;\n\t\twidth: 100%;\n\t\tborder-bottom: 2px dotted white;\n\t}\n}\n\n.amici-club {\n\twidth: 100%;\n\tpadding: 5px 7px 15px;\n\n\t&_main {\n\t\tdisplay: flex;\n\t\t.text-content {\n\t\t\twidth: 40%;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t}\n\t\th4 {\n\t\t\theight: 18px;\n\t\t\tfont-weight: 700;\n\t\t\tmargin-bottom: 8px;\n\t\t}\n\t\tspan {\n\t\t\tfont-size: 11px;\n\t\t\tcolor: var(--ion-color-dark);\n\t\t\tline-height: 1;\n\t\t}\n\t\timg {\n\t\t\tmargin-right: 14px;\n\t\t}\n\n\t\t.points {\n\t\t\tmargin-left: auto;\n\t\t\tposition: relative;\n\t\t\twidth: 54px;\n\t\t\theight: 54px;\n\t\t\timg {\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t}\n\t\t\tspan {\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 50%;\n\t\t\t\tfont-family: AppFontBold;\n\t\t\t\tfont-size: 15px;\n\t\t\t\ttop: 50%;\n\t\t\t\ttransform: translate(-50%, -60%);\n\t\t\t}\n\t\t}\n\t}\n\t&_footer {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin-top: 15px;\n\t\tion-button {\n\t\t\twidth: 47%;\n\t\t\tmin-height: 37px;\n\t\t\theight: 37px;\n\t\t}\n\t\tion-button:last-child {\n\t\t\t--background: white;\n\t\t\tcolor: var(--ion-color-primary);\n\t\t\t--border-color: var(--ion-color-primary);\n\t\t}\n\t}\n}\n\n.din-pro-cond-med {\n\tmargin-inline-start: 0;\n\tpadding-top: 2px;\n\n\tfont-family: AppFontAlt;\n\tfont-size: 10px;\n\tline-height: 16.9px;\n\ttext-align: left;\n\tcolor: #1e1e1c;\n}\n\n.checkbox-item {\n\tdisplay: flex;\n\talign-items: flex-start;\n\n\tion-checkbox {\n\t\t// margin-top: -3px;\n\t\t// --checkmark-color: #fff;\n\n\t\t--border-color: #41403b80;\n\t\t--border-color-checked: var(--randy-red-dark);\n\t\t--checkbox-background-checked: var(--randy-red-dark);\n\t\t--checkbox-background: transparent;\n\t\t--checkmark-color: #fff;\n\t}\n}\n\n.underline {\n\tposition: relative;\n\tz-index: 10;\n\ttext-decoration: none;\n\n\ta {\n\t\tcolor: var(--ion-color-black);\n\t\ttext-decoration: underline;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
